// src/pages/mission/components/MissionIntelPanel.jsx

import React from 'react';
import { Target, MapPin, Clock } from 'lucide-react';
import { getColorClasses } from '../../themeConfig';
import { formatDuration } from '../Mission.utils';

const MissionIntelPanel = ({ mission, primaryColor, alertColor }) => {
  return (
    <div className={`bg-gray-800 border ${getColorClasses(primaryColor, 'border')} rounded-lg p-6`}>
      <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
        <Target className={getColorClasses(primaryColor)} />
        Mission Intel
      </h2>

      <div className="space-y-4">
        <div>
          <p className="text-xs text-gray-400 mb-1">LOCATION</p>
          <div className="flex items-center gap-2">
            <MapPin size={16} className={getColorClasses(primaryColor)} />
            <p className="font-bold">{mission.location}</p>
          </div>
        </div>

        <div>
          <p className="text-xs text-gray-400 mb-1">ESTIMATED DURATION</p>
          <div className="flex items-center gap-2">
            <Clock size={16} className="text-yellow-400" />
            <p className="font-bold">{formatDuration(mission.duration)}</p>
          </div>
        </div>

        <div>
          <p className="text-xs text-gray-400 mb-1">THREAT ASSESSMENT</p>
          <p className={`${getColorClasses(alertColor)} font-bold`}>
            LEVEL {mission.threatLevel || 5} - {mission.risks?.casualty || 'HIGH'} RISK
          </p>
        </div>

        <div className="pt-4 border-t border-gray-700">
          <p className="text-xs text-gray-400 mb-2">MISSION BRIEF</p>
          <p className="text-sm text-gray-300">{mission.description}</p>
        </div>

        {mission.storyContext && (
          <div className={`${getColorClasses(primaryColor, 'bg')} border ${getColorClasses(primaryColor, 'border')} rounded p-3`}>
            <p className="text-xs text-gray-400 mb-1">INTELLIGENCE REPORT</p>
            <p className={`text-sm ${getColorClasses(primaryColor)} italic`}>"{mission.storyContext}"</p>
          </div>
        )}

        {mission.objectives && mission.objectives.length > 0 && (
          <div className="pt-4 border-t border-gray-700">
            <p className="text-xs text-gray-400 mb-2">OBJECTIVES</p>
            <div className="space-y-2">
              {mission.objectives.map((obj, idx) => (
                <div key={idx} className="flex items-center gap-2">
                  <div className={`w-2 h-2 ${getColorClasses(primaryColor, 'bgMain')} rounded-full`} />
                  <span className="text-sm">{obj}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="pt-4 border-t border-gray-700">
          <p className="text-xs text-gray-400 mb-2">EXPECTED REWARDS</p>
          <div className="space-y-1 text-sm">
            {mission.rewards?.funds && (
              <p className="text-green-400">💰 ${mission.rewards.funds.toLocaleString()}</p>
            )}
            {mission.rewards?.intel && (
              <p className={getColorClasses(primaryColor)}>📡 {mission.rewards.intel} Intel</p>
            )}
            {mission.rewards?.supplies && (
              <p className="text-yellow-400">📦 {mission.rewards.supplies} Supplies</p>
            )}
            {mission.rewards?.xp && (
              <p className="text-purple-400">⭐ {mission.rewards.xp} XP</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionIntelPanel;